import React, { forwardRef, ForwardRefExoticComponent, memo, RefAttributes } from 'react';
import omit from 'lodash/omit';
import classNames from 'classnames';
import isString from 'lodash/isString';

import { SvgElement } from 'vibo-ui/Icon';
import { IconProps } from './interfaces';

import useStyles from './style';

const ViboIcon = forwardRef<HTMLSpanElement, IconProps>(
  ({ icon, className, disableAutoFontSize, ...rest }, ref) => {
    const classes = useStyles();

    const prepredRest = omit(rest, ['theme', 'type', 'closeToast']);

    const isIconString = isString(icon);

    const SVGIcon = (isIconString ? null : icon) as SvgElement;

    const defaultClassName = classNames('viboIcon', className);

    return isIconString ? (
      <i
        className={classNames(`icon-${icon}`, classes.viboIcon, defaultClassName, {
          disableAutoFontSize,
        })}
        {...prepredRest}
        ref={ref}
      />
    ) : (
      <i
        className={classNames('viboIconSVG', classes.viboIconSVG, defaultClassName, {
          disableAutoFontSize,
        })}
        {...prepredRest}
        ref={ref}
      >
        <SVGIcon />
      </i>
    );
  }
);

const shouldUpdate = (prevProps: IconProps, nextProps: IconProps) => {
  return (
    prevProps.disableAutoFontSize === nextProps.disableAutoFontSize &&
    prevProps.icon === nextProps.icon &&
    prevProps.className === nextProps.className
  );
};

export default memo<ForwardRefExoticComponent<IconProps & RefAttributes<HTMLSpanElement>>>(
  ViboIcon,
  shouldUpdate
);
